import { CatExpertRouterLink } from "../../app-routing-enum";
export const experimentOverlayOptions = [
  { label: "Share", key: "share", callBack: "shareAction", disable: false },
  { label: "Clone", key: "clone", callBack: "cloneAction", disable: false },
  { label: "Delete", key: "delete", callBack: "deleteAction", disable: false },
];

export const myExperimentOverlayOptions = [
  {
    label: "Share",
    icon: "icon-share.svg",
    key: "share",
    callBack: "shareAction",
    callBackbulk: "bulkShareActionCall",
    disable: false,
  },
  {
    label: "Clone",
    icon: "icon-clone.svg",
    key: "clone",
    callBack: "cloneAction",
    callBackbulk: "bulkCloneActionCall",
    disable: false,
  },
  {
    label: "Move to",
    icon: "icon-move.svg",
    key: "move",
    callBack: "moveAction",
    callBackbulk: "bulkMoveActionCall",
    disable: false,
  },
  // {
  //   label: "Add tag",
  //   icon: "icon-tag.svg",
  //   key: "add-tag",
  //   callBack: "addTagAction",
  //   callBackbulk: "bulkAddTagActionCall",
  //   disable: true,
  // },
  // {
  //   label: "Favorite",
  //   icon: "icon-favorite.svg",
  //   key: "favorite",
  //   callBack: "favoriteAction",
  //   callBackbulk: "bulkFavoriteActionCall",
  //   disable: true,
  // },
  {
    label: "Delete",
    icon: "icon-delete.svg",
    key: "delete",
    callBack: "deleteAction",
    callBackbulk: "bulkDeleteActionCall",
    disable: false,
  },
];

export const sharedExperimentOverlayOptions = [
  { label: "Clone", key: "clone", callBack: "cloneAction", disable: false },
  {
    label: "Move to",
    key: "move",
    callBack: "moveAction",
    disable: false,
  },
];

export const keysToSelectedFolder = [
  "id",
  "name",
  "owner_id",
  "parent_id",
  "updated_at",
  "created_at",
  "full_path",
  "ancestor_ids",
  "shared_users",
];

export const experimentTypes = [
  {
    label: "Assortment",
    value: "assortment",
  },
  {
    label: "Planogram",
    value: "planogram",
  },
  {
    label: "Space planogram",
    value: "space_assortment",
  },
  {
    label: "Data exploration",
    value: "data exploration",
  },
  {
    label: "Clustering",
    value: "clustering",
  },
];

export const studioSidemenuStatic = [
  {
    label: "Home",
    slug: "/",
    activeSlug: CatExpertRouterLink.Studio,
  },
  {
    label: "My Experiments",
    slug: CatExpertRouterLink.Experiments,
    activeSlug: CatExpertRouterLink.Experiments,
  },
  {
    label: "Shared",
    slug: `${CatExpertRouterLink.Experiments}/${CatExpertRouterLink.Shared}`,
    activeSlug: CatExpertRouterLink.Shared,
  },
];

export const featureCardData = [
  {
    heading: "Store Clustering",
    id: "fourth",
    key: "clustering",
    image: "icon-store-clustering.svg",
    description: `Build your store clusters using different data sources such as sell-out and socio-demographic data.`,
    show: true,
  },
  {
    heading: "Assortment",
    id: "fourth",
    key: "assortment",
    image: "icon-product-feature.svg",
    description: `Simulation different scenarios to discover which SKU mix drives
      the highest incremental revenue for the retailer.`,
    show: true,
  },
  {
    heading: "Planogram",
    id: "fifth",
    key: "plano",
    image: "icon-planogram.svg",
    description: `Simulation different scenarios to discover which SKU mix drives the highest incremental revenue for the retailer.`,
    show: true,
  },
  {
    heading: "Bulk Operations",
    id: "ninth",
    key: "bulk",
    image: "icon-bulk-opration.svg",
    description:
      "Manage SKUs across planograms at scale - import, edit, and export in just a few clicks",
    show: true,
  },
  // {
  //   heading: "Product Library",
  //   id: "ninth",
  //   key: "product-library",
  //   image: "icon-product-library.svg",
  //   description: "Using in-built templates, generate insights about your data.",
  //   show: true,
  // },
  {
    heading: "Libraries",
    id: "ninth",
    key: "libraries",
    image: "icon-product-library.svg",
    description:
      "Browse & manage Products & Fixtures to create rich sources for planograms.",
    show: true,
  },
  {
    heading: "Dashboard",
    id: "tenth",
    key: "dashboard-view",
    image: "icon-plano-dashboard-active.svg",
    description: "Manage your overall level data with KPIs and charts.",
    show: true,
  },
  {
    heading: "AI Imagery",
    id: "tenth",
    key: "ai-imagery",
    image: "icon-plano-dashboard-active.svg",
    description:
      "AI platform for SKU image creation — generate product visuals from prompts, bulk-create images, and maintain a reference library for consistent branding.",
    show: true,
  },
];

export const librariesCardData = [
  {
    heading: "Product Library",
    id: "first",
    key: "product-library",
    image: "icon-product-library.svg",
    route: "/product-library",
    description: "Using in-built templates, generate insights about your data.",
    show: true,
  },
  {
    heading: "Fixture Library",
    id: "second",
    key: "fixture-library",
    image: "icon-product-library.svg",
    route: "/fixture-library",
    description: "Using in-built templates, generate insights about your data.",
    show: true,
  },
];

export const experimentListTableColumn = [
  {
    label: "",
    value: "check_box",
    valueType: "",
    filterType: "",
    inputType: "checkbox",
    sortable: false,
    disabled: true,
  },
  {
    label: "Name",
    value: "name",
    valueType: "",
    filterType: "input_text",
    sortable: true,
  },
  {
    label: "Type",
    value: "experiment_type",
    valueType: "",
    filterType: "dropdown",
    filterOptions: experimentTypes,
    selectedFilterValues: [],
    sortable: true,
  },
  {
    label: "Country",
    value: "country",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
  },
  {
    label: "Region",
    value: "region",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
  },
  {
    label: "Key Accounts",
    value: "key_account",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
  },
  {
    label: "Modified at",
    value: "created_at",
    valueType: "",
    sortable: true,
  },
  {
    label: "Shared by",
    value: "owner_by",
    valueType: "",
    sortable: false,
    disabled: true,
  },
  {
    label: "Status",
    value: "status",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
  },
  {
    label: "",
    value: "action",
    valueType: "dot-view",
    actionList: myExperimentOverlayOptions,
  },
];

const tabDetails = [
  {
    heading: "All",
    key: "all",
  },
  {
    heading: "Planogram",
    key: "planogram",
  },
  {
    heading: "Assortment",
    key: "assortment",
  },
];

export const experimentTabHeadDetails = {
  [CatExpertRouterLink.Studio]: {
    title: "Experiments",
    tabDetails,
  },
  [CatExpertRouterLink.Experiments]: {
    title: "My Experiments",
    tabDetails,
  },
  [CatExpertRouterLink.Shared]: {
    title: "Shared",
    tabDetails,
  },
};

export const confirmDialogContent = {
  head: "Delete Experiment",
  description: "Are you sure you want to delete the selected experiments?",
  description_text:
    "Please note this will delete it permanently and cannot be restored.",
  btnCancel: "Cancel",
  btnProceed: "Delete",
  btnProceedClass: "delete",
  showConfirmDialog: false,
  hasMultiple: false,
  styleClass: "confirm-dialog",
  dialogkey: "delete",
};

export const newFolderDialogContent = {
  head: "Create New Folder",
  folderLocation: "",
  btnCancel: "Cancel",
  btnProceed: "Add",
  btnProceedClass: "delete",
  showFolderDialog: false,
  styleClass: "new-folder-dialog",
  dialogkey: "delete",
  formField: [
    {
      label: "Folder Name",
      placeholder: "Enter Name",
      type: "text",
      model: "name",
      isRequired: true,
      maxLength: 50,
      errors: [
        {
          key: "required",
          message: "Please enter the folder name",
        },
        {
          key: "maxlength",
          message: "Please enter no more than 50 characters.",
        },
      ],
    },
  ],
};

export const moveExperimentFolderDialogContent = {
  title: "Move 1 Items",
  showMoveDialog: false,
  hasMultiple: false,
  tabDetails: [
    {
      heading: "My Experiments",
      key: CatExpertRouterLink.Experiments,
    },
    {
      heading: "Shared",
      key: CatExpertRouterLink.Shared,
    },
  ],
  folderLocation: [],
  styleClass: "move-dialog",
  btnCancel: "Cancel",
  btnProceed: "Move here",
};

export interface Breadcrumb {
  label: string;
  slug?: string;
  folder_id?: string;
}

export type FilterProperties = {
  filterExperimentTypes: any[];
  filterKeyAccountIds: any[];
  filterCountries: any[];
  filterRegions: any[];
  filterStatus: any[];
};
